
/* Fabulla theme — shared behaviour */
(function () {
  var T = window.fabT || {};
  var RTL = document.documentElement.dir === 'rtl';
  var s = document.querySelectorAll('#ticker span'), i = 0;
  if (s.length > 1) setInterval(function () { s[i].classList.remove('on'); i = (i + 1) % s.length; s[i].classList.add('on'); }, 4200);

  var hdr = document.getElementById('hdr');
  if (hdr) addEventListener('scroll', function () { hdr.classList.toggle('small', scrollY > 80); }, { passive: true });

  /* publish the header height so sticky toolbars can offset by it */
  var wrapper = document.getElementById('shopify-section-header') || hdr;
  function headerHeight() {
    if (!wrapper) return;
    document.documentElement.style.setProperty('--hdr-h', Math.round(wrapper.getBoundingClientRect().height) + 'px');
  }
  headerHeight();
  addEventListener('resize', headerHeight, { passive: true });
  addEventListener('scroll', headerHeight, { passive: true });

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { threshold: .1, rootMargin: '0px 0px -30px' });
    document.querySelectorAll('.rv').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('.rv').forEach(function (el) { el.classList.add('in'); });
  }
  requestAnimationFrame(function () { document.querySelectorAll('.above .rv').forEach(function (el) { el.classList.add('in'); }); });

  var toast = document.getElementById('toast'), tm;
  window.fabToast = function (msg) {
    if (!toast) return;
    toast.textContent = msg; toast.classList.add('on');
    clearTimeout(tm); tm = setTimeout(function () { toast.classList.remove('on'); }, 3200);
  };

  function refreshBag() {
    fetch(window.Shopify.routes.root + 'cart.js').then(function (r) { return r.json(); }).then(function (c) {
      document.querySelectorAll('[data-bag-count]').forEach(function (el) { el.textContent = c.item_count; });
    }).catch(function () {});
  }

  /* add to cart without leaving the page */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('form[data-ajax-cart]')) return;
    e.preventDefault();
    var btn = form.querySelector('[type=submit]'), label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = T.adding || 'Adding…'; }
    fetch(window.Shopify.routes.root + 'cart/add.js', { method: 'POST', body: new FormData(form) })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok) { window.fabToast(res.d.description || T.no_stock || 'Not enough stock'); return; }
        refreshBag();
        document.dispatchEvent(new CustomEvent('fab:added', { detail: res.d }));
        if (!document.getElementById('cartdrawer')) window.fabToast((form.dataset.title || '') + ' — ' + (T.added || 'added to your bag'));
      })
      .catch(function () { window.fabToast(T.error || 'Something went wrong — please try again'); })
      .finally(function () { if (btn) { btn.disabled = false; btn.textContent = label; } });
  });

  /* mobile menu + filter drawer */
  var menu = document.getElementById('mobilemenu'), mbtn = document.querySelector('.menubtn');
  if (mbtn && menu) mbtn.addEventListener('click', function () { menu.classList.toggle('open'); });
  var side = document.getElementById('side'), openf = document.getElementById('openf'), closef = document.getElementById('closef');
  if (openf && side) openf.addEventListener('click', function () { side.classList.add('open'); });
  if (closef && side) closef.addEventListener('click', function () { side.classList.remove('open'); });

  /* product carousels */
  document.querySelectorAll('[data-carousel]').forEach(function (wrap) {
    var rail = wrap.querySelector('.rail');
    if (!rail) return;
    var prev = wrap.querySelector('[data-prev]'), next = wrap.querySelector('[data-next]'), nav = wrap.querySelector('.cnav');
    var dir = RTL ? -1 : 1;
    function step() { return Math.max(160, rail.clientWidth * 0.8); }
    function update() {
      var max = rail.scrollWidth - rail.clientWidth - 2, pos = Math.abs(rail.scrollLeft);
      if (nav) nav.style.display = max > 4 ? '' : 'none';
      if (prev) prev.disabled = pos <= 2;
      if (next) next.disabled = pos >= max;
    }
    if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -step() * dir, behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { rail.scrollBy({ left: step() * dir, behavior: 'smooth' }); });
    rail.addEventListener('scroll', update, { passive: true });
    addEventListener('resize', update, { passive: true });
    update();
  });

  /* collection: auto-apply filters and sort */
  var facet = document.getElementById('FacetForm');
  if (facet) {
    facet.addEventListener('change', function () { facet.submit(); });
    var sort = document.getElementById('sort');
    if (sort) sort.addEventListener('change', function () {
      var f = document.getElementById('SortForm'); if (f) f.submit();
    });
  }

  /* product gallery + zoom */
  var mainimg = document.getElementById('mainimg');
  if (mainimg) {
    document.querySelectorAll('.thumb').forEach(function (t) {
      t.addEventListener('click', function () {
        mainimg.src = t.dataset.src;
        mainimg.srcset = '';
        if (t.dataset.full) mainimg.dataset.full = t.dataset.full;
        document.querySelectorAll('.thumb').forEach(function (o) { o.classList.remove('on'); });
        t.classList.add('on');
      });
    });

    var lb = document.getElementById('lb'), lbimg = document.getElementById('lbimg'), lbwrap = document.getElementById('lbwrap'), lbx = document.getElementById('lbx');
    if (lb && lbimg) {
      function closeLb() { lb.hidden = true; lb.classList.remove('z'); document.documentElement.style.overflow = ''; }
      mainimg.addEventListener('click', function () {
        lbimg.src = mainimg.dataset.full || mainimg.src;
        lb.classList.remove('z');
        lb.hidden = false;
        document.documentElement.style.overflow = 'hidden';
      });
      lbimg.addEventListener('click', function (e) {
        e.stopPropagation();
        var r = lbimg.getBoundingClientRect(), fx = (e.clientX - r.left) / r.width, fy = (e.clientY - r.top) / r.height;
        lb.classList.toggle('z');
        if (lb.classList.contains('z')) {
          requestAnimationFrame(function () {
            lbwrap.scrollLeft = fx * lbwrap.scrollWidth - lbwrap.clientWidth / 2;
            lbwrap.scrollTop = fy * lbwrap.scrollHeight - lbwrap.clientHeight / 2;
          });
        }
      });
      lbx.addEventListener('click', closeLb);
      lb.addEventListener('click', function (e) { if (e.target === lb || e.target === lbwrap) closeLb(); });
      addEventListener('keydown', function (e) { if (e.key === 'Escape' && !lb.hidden) closeLb(); });
    }
  }

  /* product: options, variant, quantity */
  var dataEl = document.getElementById('variantData');
  var data = dataEl ? JSON.parse(dataEl.textContent) : [];
  var idInput = document.getElementById('variantId');
  var q = document.getElementById('q'), qty = document.getElementById('qtyInput');
  var plus = document.getElementById('plus'), minus = document.getElementById('minus');
  var note = document.getElementById('stocknote');
  var addBtn = document.getElementById('addbtn'), stickyAdd = document.getElementById('stickyadd');
  var priceEl = document.getElementById('livePrice'), stickyEl = document.getElementById('stickysize'), skuEl = document.getElementById('skucode');

  function currentVariant() {
    if (!idInput) return null;
    return data.find(function (x) { return String(x.id) === String(idInput.value); }) || null;
  }
  function maxQ() {
    var v = currentVariant(), cap = 9;
    if (v && v.inventory !== null && v.inventory !== undefined) cap = Math.min(cap, Math.max(1, v.inventory));
    return cap;
  }
  function showNote(forceLimit) {
    if (!note) return;
    var v = currentVariant();
    if (v && v.available && v.inventory !== null && v.inventory !== undefined && v.inventory > 0 && (v.inventory <= 5 || forceLimit)) note.textContent = (T.only_left || 'Only %n available').replace('%n', v.inventory);
    else note.textContent = '';
  }
  function setQ(n, quiet) {
    if (!q || !qty) return;
    var m = maxQ(), hit = n > m;
    n = Math.min(m, Math.max(1, n));
    q.textContent = n; qty.value = n;
    showNote(hit);
    if (hit && !quiet) window.fabToast((T.only_left_size || 'Only %n available in this size').replace('%n', m));
  }
  if (plus) plus.addEventListener('click', function () { setQ(parseInt(q.textContent, 10) + 1); });
  if (minus) minus.addEventListener('click', function () { setQ(parseInt(q.textContent, 10) - 1); });
  showNote(false);

  var opts = document.getElementById('opts');
  if (opts && data.length) {
    var groups = opts.querySelectorAll('.optgroup');
    var cur = currentVariant() || data[0];
    var sel = cur.options.slice();

    function match(s) { return data.find(function (v) { return v.options.every(function (o, i) { return o === s[i]; }); }); }
    function refresh() {
      /* availability of each value given the other selections */
      groups.forEach(function (g) {
        var gi = parseInt(g.dataset.index, 10);
        g.querySelectorAll('.size').forEach(function (b) {
          var test = sel.slice(); test[gi] = b.dataset.value;
          var v = match(test);
          b.classList.toggle('on', sel[gi] === b.dataset.value);
          b.classList.toggle('out', !v || !v.available);
        });
        var lbl = g.querySelector('[data-optval]'); if (lbl) lbl.textContent = sel[gi];
      });
      var v = match(sel);
      if (!v) return;
      idInput.value = v.id;
      if (priceEl) priceEl.innerHTML = '<span class="now">' + v.price_label + '</span>' + (v.compare_label ? '<s>' + v.compare_label + '</s><span class="save">' + (T.save || 'Save') + ' ' + v.save_label + '</span>' : '');
      if (stickyEl) stickyEl.textContent = v.price_label + ' · ' + v.title;
      if (skuEl) skuEl.textContent = v.sku ? (T.code || 'Code#') + ' ' + v.sku : '';
      [addBtn, stickyAdd].forEach(function (b) { if (!b) return; b.disabled = !v.available; });
      if (addBtn) addBtn.textContent = v.available ? (T.add_to_cart || 'Add to bag') : (T.sold_out || 'Sold out');
      if (history.replaceState) history.replaceState(null, '', location.pathname + '?variant=' + v.id);
      setQ(parseInt(q ? q.textContent : 1, 10), true);
    }
    opts.addEventListener('click', function (e) {
      var b = e.target.closest('.size'); if (!b) return;
      sel[parseInt(b.dataset.index, 10)] = b.dataset.value;
      if (!match(sel) || !match(sel).available) {
        /* jump to the nearest available combination for the value just picked */
        var gi = parseInt(b.dataset.index, 10);
        var alt = data.find(function (v) { return v.available && v.options[gi] === b.dataset.value; });
        if (alt) sel = alt.options.slice();
      }
      refresh();
    });
    refresh();
  }

  var sg = document.getElementById('sgbtn');
  if (sg) sg.addEventListener('click', function () { var t = document.getElementById('sgtable'); if (t) t.classList.toggle('on'); });
})();
